import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { SelectItem } from 'primeng/api';
import { MensajesConstantes} from '../constantes/mensajes'




@Injectable()
export class Constantes{

    // ===================== CONSTANTES DEL ALFRESCO =======================
    public static ID_CARPETA_FOTOS_PRODUCTOS_CATERING: string = environment.ID_CARPETA_FOTOS_PRODUCTOS_CATERING;
    public static URL_API_ALFRESCO_DESCARGA = environment.URL_API_ALFRESCO_DESCARGA;    
    public static URL_API_ALFRESCO_SUBIDA = environment.URL_API_ALFRESCO_SUBIDA;    
    public static NOMBRE_CARPETA_FOTOS_PRODUCTOS_ALFRESCO = '{"codigoCarpetaPadre": "' + Constantes.ID_CARPETA_FOTOS_PRODUCTOS_CATERING + '","nombreCarpetaHijo": "fotosProductosCatering"}';
    public static NOMBRE_CARPETA_FOTOS_FICHAS_ESTANDAR='{"codigoCarpetaPadre": "' + Constantes.ID_CARPETA_FOTOS_PRODUCTOS_CATERING + '","nombreCarpetaHijo": "fotosFichasEstandar"}'; 
    // ===================== CONSTANTES DE SERVICIOS =======================

    public static URL_SERVER_SAR: string = environment.URL_SAR;

    public static URL_LOGOUT: 'logout';

    public static caracteresRegex: RegExp = new RegExp(/^[a-zA-Z0-9áéíóúÁÉÍÓÚñÑ* ]+$/);


    // ===================== ENVIRONMENT =====================

    public static SERVER_CATERING: String = environment.envURL_CATERING

    /**
     * Permite mostrar los id en las tablas
     */

    public static mostrarIdentificador = true;

    /**
     * ES la cabecera para mandar en los REST
     */
    public static HEADERS = new Headers({ 'Content-Type': 'application/json' });

    /**
    * Es la url para recuperar las unidades 
    */
    public static URL_UNIDAD: String = environment.URL_UNIDAD
    public static URL_PERSONA: String = environment.URL_UNIDAD

    /**
     *URLs para el manejo de las unidades y roles
     */
    public static URL_USUARIO: String = environment.URL_USUARIO
    public static URL_UNIDADADMINISTRATIVA: String = environment.URL_UNIDADADMINISTRATIVA
    public static URL_USUARIOXROLXUNIDAD: String = environment.URL_USUARIOXROLXUNIDAD;
    /**
     * URLS internas
    */
    public static URL_ASOCIAR_JEFE_DEPENDENCIA: string = '/asociar-jefe-dependencia';
    public static URL_AGREGAR_JEFE_DEPENDENCIA: string = '/agregar-jefe-dependencia';
    /******************************CONSTANTES******************************************************* */

    public static TIPO_DISPONIBILIDAD_NORMAL = 'NORMAL';
    public static TIPO_DISPONIBILIDAD_EXCEPCIONAL = 'EXCEPCIONAL';
    public static ESTA_ACTIVO_SI = 'S';
    public static ESTADO_ACTIVO_DISPONIBILIDAD = 'A';
    public static ESTADO_INACTIVO_DISPONIBILIDAD = 'I';
    public static ESTADO_ACTIVO_DESCRIPCION = 'ACTIVO';
    public static ESTADO_INACTIVO_DESPCIPCION = 'INACTIVO';

    public static PLANIFICACION = 'PLANIFICACIÓN';

    

    public static MESES: SelectItem[] = [{ label: 'enero', value: 0 },
    { label: 'febrero', value: 1 },
    { label: 'marzo', value: 2 },
    { label: 'abril', value: 3 },
    { label: 'mayo', value: 4 },
    { label: 'junio', value: 5 },
    { label: 'julio', value: 6 },
    { label: 'agosto', value: 7 },
    { label: 'septiembre', value: 8 },
    { label: 'octubre', value: 9 },
    { label: 'noviembre', value: 10 },
    { label: 'diciembre', value: 11 }];

    public static mapMESES = new Map ([["ENERO",0],    
                                       ["FEBRERO",1],
                                       ["MARZO",2],
                                       ["ABRIL",3],
                                       ["MAYO",4],
                                       ["JUNIO",5],
                                       ["JULIO",6],
                                       ["AGOSTO",7],
                                       ["SEPTIEMBRE",8],
                                       ["OCTUBRE",9],
                                       ["NOVIEMBRE",10],
                                       ["DICIEMBRE",11]
                                    ])


    public static ESTADO_REQUERIMIENTOS: SelectItem[] = [{ label: 'APROBAR', value: 'APROBADA' },
    { label: 'NO APROBAR', value: 'NO APROBADA' }];

    public static ESTADO_REQUERIMIENTOS_CONFIRMAR_CANCELAR: SelectItem[] = [{ label: 'CONFIRMAR', value: 'CONFIRMADA' },
    { label: 'CANCELAR', value: 'CANCELADA' }];

    public static ESTADO_TIPOS_VISTAS_PLANIFICACIONES: SelectItem[] = [{ label: 'LISTADO', value: 'LISTADO' }, { label: 'CALENDARIO', value: 'CALENDARIO' }];
    public static ESTADO_TIPOS_VISTAS_PRODUCCION: SelectItem[] = [{ label: 'LISTADO', value: 'LISTADO AGRUPADO' }, { label: 'CALENDARIO', value: 'CALENDARIO' }];

   
   
    public static ESTADO_NOAPROBADO = 'NO APROBADA';
    public static ESTADO_APROBADA = 'APROBADA';
    public static ESTADO_ACEPTADA = 'ACEPTADA';
    public static ESTADO_ELABORADA = 'ELABORADA';
    public static ESTADO_PORAPROVAR = 'POR APROBAR';
    public static ESTADO_CONFIRMAR = 'CONFIRMADA';
    public static ESTADO_CANCELAR='CANCELADA';
    public static ESTADO_RECHAZAR='RECHAZADA';
    public static ESTADO_NOCONFIRMADA='NO CONFIRMADA';
    public static ESTADO_PLANIFICACION_PENDIENTE = 'PENDIENTE';
    public static ESTADO_PLANIFICACION_REVISADO = 'REVISADO';
    public static PRE_ELABORADO='PRE-ELABORADO';

    public static TIPO_CONFIGURACION_PORCENTAJE='PORCENTAJE SERVICIO CATERING'; 
    public static TIPO_CONFIGURACION_CONFIRMAR='TIEMPO LIMITE CONFIRMAR SERVICIO';
    public static TIPO_CONFIGURACION_CANCELAR ='TIEMPO LIMITE CANCELAR SERVICIO';
    public static TIPO_CONFIGURACION_LIMITE_PRODUCCION='LIMITE';

    public static COLOR_ESTADO_ELABORADA:string = '#0277BD';
    public static COLOR_ESTADO_PORAPROBAR:string = '#FF9800';
    public static COLOR_ESTADO_APROBADA:string = '#01b461';
    public static COLOR_ESTADO_NOAPROBADA:string = '#AD1457';
    public static COLOR_ESTADO_ACEPTADA:string = '#4527A0';
    public static COLOR_ESTADO_RECHAZADA:string = '#F44336';
    public static COLOR_ESTADO_CONFIRMADA:string = '#795548';
    public static COLOR_ESTADO_NOCONFIRMADA:string = '#dd04b9';
    public static COLOR_ESTADO_CANCELADA:string = '#d9d9d9';
    
    public static PARTIDA: SelectItem[] = [{ label: 'FRIO', value: 'FRIO' },
                                           { label: 'CALIENTE', value: 'CALIENTE' }];

    public static DIFICULTAD: SelectItem[] = [{ label: 'FACIL', value: 'FACIL' },
                                           { label: 'MEDIO', value: 'MEDIO'},
                                           { label: 'AVANZADO', value: 'AVANZADO' }];

    public static COLORS_CALENDARIO = [Constantes.COLOR_ESTADO_ELABORADA,Constantes.COLOR_ESTADO_PORAPROBAR, Constantes.COLOR_ESTADO_APROBADA, Constantes.COLOR_ESTADO_NOAPROBADA,Constantes.COLOR_ESTADO_ACEPTADA,Constantes.COLOR_ESTADO_RECHAZADA];

    public static UNIDAD_MEDIADA : SelectItem[] = [{ label: 'GRAMOS', value: 'GRAMOS' },
                                                    { label: 'MILIGRAMOS', value: 'MILIGRAMOS' },
                                                    { label: 'UNIDAD', value: 'UNIDAD' }];      
                                                      
    public static TIPO_FICHA : SelectItem[] = [{ label: 'NORMAL', value: 'NORMAL' },
                                               { label: 'PRE-ELABORADO', value: 'PRE-ELABORADO' }];    
}
